import { J_OCCASIONS, G_OCCASIONS, H_OCCASIONS } from '../configs/occasions'
import { hijriMonthLength } from './hijri'
import { IDayCell } from './calendar'

// Decodes the compact occasion lists (see configs/occasions.ts for the
// conventions) and matches them against a day expressed in all three
// calendars. Hijri 'lstday' entries become day 0 and are resolved against the
// observed month length at match time. Titles are stored expanded except the
// Gregorian list's 'ج.' shorthand; broader abbreviation rules would corrupt
// ordinary words ending in those letters (e.g. 'باقر.' → 'باقروز').

// Which of the three lists an occasion came out of. Only the override store
// uses it, to key a rename to the occasion rather than to a date — see
// services/occasion-overrides.
export type OccasionCalendar = 'j' | 'g' | 'h'

export interface IOccasion {
    day: number // 1-based; 0 = last day of the (hijri) month
    month: number
    title: string
    isHoliday: boolean
    from: OccasionCalendar
}

function expand(source: (number | string)[], from: OccasionCalendar): IOccasion[] {
    const out: IOccasion[] = []
    for (let i = 0; i + 2 < source.length; i += 3) {
        const d = source[i]
        out.push({
            day: typeof d === 'number' ? Math.abs(d) : 0,
            month: source[i + 1] as number,
            isHoliday: String(d).includes('-'),
            title: (source[i + 2] as string).replace(/ج\./gu, 'روز جهانی'),
            from,
        })
    }
    return out
}

const J = expand(J_OCCASIONS, 'j')
const G = expand(G_OCCASIONS, 'g')
const H = expand(H_OCCASIONS, 'h')

function forDay(cell: IDayCell): IOccasion[] {
    return [
        ...J.filter(o => o.month === cell.jm && o.day === cell.jd),
        ...G.filter(o => o.month === cell.gm && o.day === cell.gd),
        ...H.filter(o => o.month === cell.hm &&
            (o.day === cell.hd || (o.day === 0 && cell.hd === hijriMonthLength(cell.hy, cell.hm)))),
    ]
}

export default { forDay }
